module.exports = __webpack_public_path__ + "static/img/IMG_20170729_175013.14ae796e.jpg";